// extracted by mini-css-extract-plugin
module.exports = {"btnBlue":"_base-button_btnBlue_1Bo95","btnBlueOutline":"_base-button_btnBlueOutline_2z4RD","invalidCoding":"_base-button_invalidCoding_3Kbl8","button":"_base-button_button_1_hTJ"};